<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" md="6">
                <table class="table">
                    <tbody>
                        <b-form-group>
                            <div class="estimated-reach-div">
                                <div class="estimated-reach-container">
                                    <label for="estimated-reach" class="estimated-reach-text">{{
                                        estimatedReachTopLabel
                                    }}</label>
                                </div>
                                <div>
                                    <label style="font-weight: 800; font-size: 0.8rem"
                                        >*Guests must have Staylio app installed</label
                                    >
                                </div>
                            </div>
                        </b-form-group>
                        <b-form-group :description="`${titleLength}/${titleMaxLength} characters`">
                            <label for="title" class="pt-3">Title</label>
                            <input
                                type="text"
                                class="form-control"
                                id="title"
                                v-model="title"
                                :maxlength="titleMaxLength"
                            />
                        </b-form-group>
                        <b-form-group description="">
                            <label for="message">Message</label>
                            <textarea class="form-control" id="message" v-model="message"></textarea>
                        </b-form-group>

                        <b-form-group label="Send To Rules">
                            <b-row v-if="rulesArray.length <= 0">
                                <b-col cols="12">
                                    <p style="color: #999; font-style: italic">
                                        No rules added (Sending to All Staylio Guests)
                                    </p>
                                </b-col>
                            </b-row>
                            <template v-for="(rule, index) in rulesArray" :key="index">
                                <b-row class="mb-2 d-flex flex-column flex-md-row">
                                    <b-col cols="12" md="5" class="mb-2 mb-md-0">
                                        <b-form-select
                                            v-model="rule[0]"
                                            :options="previewSendToRuleOptions"
                                            @input="updateSelectedRule(index)"
                                        ></b-form-select>
                                    </b-col>
                                    <template v-if="rule[0] != null">
                                        <b-col v-if="rule[0] < 2" cols="12" md="7" class="mb-2 mb-md-0 d-flex">
                                            <b-form-datepicker v-model="rule[1]"></b-form-datepicker>
                                            <b-button class="ml-2" @click="removeRule(index)" variant="danger">
                                                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
                                            </b-button>
                                        </b-col>
                                        <b-col v-else-if="rule[0] == 6" cols="12" md="7" class="mb-2 mb-md-0 d-flex">
                                            <b-form-select v-model="rule[1]" :options="statusOptions"></b-form-select>
                                            <b-button class="ml-2" @click="removeRule(index)" variant="danger">
                                                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
                                            </b-button>
                                        </b-col>
                                        <b-col
                                            v-else-if="rule[0] == 4 || rule[0] == 5"
                                            cols="12"
                                            md="7"
                                            class="mb-2 mb-md-0 d-flex"
                                        >
                                            <b-form-select v-model="rule[1]" :options="ageOptions"></b-form-select>
                                            <b-button class="ml-2" @click="removeRule(index)" variant="danger">
                                                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
                                            </b-button>
                                        </b-col>
                                        <b-col
                                            v-else-if="rule[0] == 2 || rule[0] == 3"
                                            cols="12"
                                            md="7"
                                            class="mb-2 mb-md-0 d-flex"
                                        >
                                            <b-form-select
                                                v-model="rule[1]"
                                                :options="stayCountOptions"
                                            ></b-form-select>
                                            <b-button class="ml-2" @click="removeRule(index)" variant="danger">
                                                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
                                            </b-button>
                                        </b-col>
                                        <b-col v-else-if="rule[0] == 7" cols="12" md="7" class="mb-2 mb-md-0 d-flex">
                                            <b-form-input
                                                :disabled="true"
                                                v-model="previewSelectedGuests"
                                            ></b-form-input>
                                            <b-button
                                                class="ml-2"
                                                variant="primary"
                                                @click="$bvModal.show('selected-guest-modal')"
                                            >
                                                Edit
                                            </b-button>
                                            <b-button class="ml-2" @click="removeRule(index)" variant="danger">
                                                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
                                            </b-button>
                                        </b-col>
                                        <b-col v-else cols="12" md="7" class="mb-2 mb-md-0 d-flex">
                                            <b-form-input v-model="rule[1]" type="number"></b-form-input>
                                            <b-button class="ml-2" @click="removeRule(index)" variant="danger">
                                                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
                                            </b-button>
                                        </b-col>
                                    </template>

                                    <b-col v-else cols="12" md="7" class="mb-2 mb-md-0 d-flex">
                                        <b-form-input disabled v-model="rule[1]"></b-form-input>
                                        <b-button class="ml-2" @click="removeRule(index)" variant="danger">
                                            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </template>

                            <b-button @click="addRule" variant="primary">Add Rule</b-button>
                        </b-form-group>
                    </tbody>
                </table>

                <div class="device-preview">
                    <Segment :options="segmentOptions" style="width: 100%" @selected="updateSegmentSelected" />
                    <IphonePreview v-if="segmentSelected == 0" :title="title" :message="message" />
                    <AndroidPreview v-else :title="title" :message="message" />
                </div>

                <b-row
                    style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin: 0px;
                        margin-top: 2px;
                        margin-bottom: 2rem;
                    "
                >
                    <p>{{ estimatedReachLabel }}</p>
                    <b-button
                        variant="primary"
                        @click="$bvModal.show('confirm-send-mass-push')"
                        class="mt-2 ml-2"
                        style="min-width: 150px"
                        :disabled="!title || !message"
                    >
                        Send
                        <font-awesome-icon :icon="['fas', 'paper-plane']" class="ml-2"></font-awesome-icon>
                    </b-button>
                </b-row>
            </b-col>
        </b-row>
    </b-container>

    <MassPushNotificationSelectedGuestsModal :selectedGuests="selectedGuests"></MassPushNotificationSelectedGuestsModal>

    <modal id="confirm-send-mass-push" title="Confirm" ok-title="Send" @ok="onCreate">
        <p>You are about to send a push notification to {{ sendToCount }} guests. Are you sure you want to proceed?</p>
        <p>Please double-check your message for spelling and grammar errors before sending.</p>
        <div class="device-preview">
            <Segment
                :options="segmentOptions"
                style="width: 100%"
                @selected="updateModalSegmentSelected"
                :initialSelection="modalSegmentSelected"
            />
            <IphonePreview v-if="modalSegmentSelected == 0" :title="title" :message="message" />
            <AndroidPreview v-else :title="title" :message="message" />
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import API from '../../../api';
    import { MASS_PUSH_NOTIFICATION_ENDPOINT } from '../../../endpoints';
    import page from '../../generic/page/page.vue';
    import format from 'date-fns/format';
    import Modal from '../../generic/modal/modal.vue';
    import MassPushNotificationSelectedGuestsModal from './mass-push-notification-selected-guests-modal.vue';
    import IphonePreview from './iphone-preview.vue';
    import Segment from '../../generic/segment/segment.vue';
    import AndroidPreview from './android-preview.vue';

    export default {
        components: {
            page,
            Modal,
            MassPushNotificationSelectedGuestsModal,
            IphonePreview,
            Segment,
            AndroidPreview,
        },
        name: 'MassPushNotificationCreate',
        data() {
            return {
                busy: false,
                title: '',
                titleMaxLength: 40,
                message: '',
                rulesArray: [],
                expandText: false,
                expandTextModal: false,
                statusOptions: [
                    {
                        value: null,
                        text: 'Select Status',
                    },
                    {
                        value: 'None',
                        text: 'No Status',
                    },
                    {
                        value: 'VIP',
                        text: 'VIP',
                    },
                    {
                        value: 'Blocklist',
                        text: 'Blocklist',
                    },
                ],
                stayCountOptions: [
                    {
                        value: null,
                        text: 'Select Stay Count',
                    },
                ],
                ageOptions: [
                    {
                        value: null,
                        text: 'Select Age',
                    },
                ],
                sendToRules: null,
                sendToCount: 0,
                sendToRulesOptions: null,
                characterPreviewLimit: 250,
                selectedGuests: [],
                segmentOptions: [
                    {
                        label: 'iPhone',
                        icon: 'fab fa-apple',
                    },
                    {
                        label: 'Android',
                        icon: 'fab fa-android',
                    },
                ],
                segmentSelected: 0,
                modalSegmentSelected: 0,
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat', 'userTimeFormat']),
            ...mapGetters('guest', ['notifySelectedGuests']),
            titleLength() {
                return this.title.length;
            },
            formatSendTo() {
                return this.rulesArray.reduce(
                    (acc, rule) => {
                        if (rule[0] == 7) {
                            acc[7] = this.selectedGuests.map((guest) => guest.value);
                        } else if (rule[0] == 6) {
                            if (!acc[6]) {
                                acc[6] = {};
                            }
                            const nextKey = Object.keys(acc[6]).length + 1;
                            acc[6][nextKey] = rule[1];
                        } else if (rule[0] != null) {
                            acc[rule[0]] = rule[1];
                        }
                        return acc;
                    },
                    {
                        0: null,
                        1: null,
                        2: null,
                        3: null,
                        4: null,
                        5: null,
                        6: {},
                        7: [],
                    }
                );
            },
            previewSelectedGuests() {
                if (this.selectedGuests.length === 0) {
                    return 'None Selected';
                } else if (this.selectedGuests.length === 1) {
                    return `(${this.selectedGuests[0].value}: ${this.selectedGuests[0].text})`;
                } else {
                    return `(${this.selectedGuests[0].value}: ${this.selectedGuests[0].text}) +${
                        this.selectedGuests.length - 1
                    } more`;
                }
            },
            previewSendToRuleOptions() {
                if (this.sendToRulesOptions == null) {
                    return [];
                }
                return this.sendToRulesOptions.map((option) => {
                    if (this.rulesArray.some((rule) => rule[0] == option.value && rule[0] != 6)) {
                        return {
                            ...option,
                            disabled: true,
                        };
                    }
                    return option;
                });
            },
            estimatedReachLabel() {
                return `Estimated Reach: ${this.sendToCount} Guests*`;
            },
            estimatedReachTopLabel() {
                return `Estimated Reach: ${this.sendToCount}${
                    this.selectedGuests.length > 0 ? ' of ' + this.selectedGuests.length : ''
                } Guests`;
            },
        },
        mounted() {
            for (let i = 0; i < 200; i++) {
                if (i < 100) {
                    this.ageOptions.push({
                        value: i,
                        text: i + ' years old',
                    });
                }
                this.stayCountOptions.push({
                    value: i,
                    text: i + ' stays',
                });
            }

            let list = this.notifySelectedGuests;
            if (list && list.length > 0) {
                this.rulesArray.push([7, null]);
                this.selectedGuests = list;
                this.setNotifySelectedGuests([]);
            }

            this.getSendToCount();
            this.getRules();
        },
        methods: {
            ...mapMutations('guest', ['setNotifySelectedGuests']),
            async onCreate() {
                if (!this.title || !this.message) {
                    this.errorToast({ text: 'Title and Message are required' });
                    return;
                }
                try {
                    await API.post(`${MASS_PUSH_NOTIFICATION_ENDPOINT()}create-campaign/`, {
                        title: this.title,
                        message: this.message,
                        send_to: this.formatSendTo,
                    });
                    this.$router.push(`/app/staylio-app/mass-push-notification/list/`);
                    this.$refs.grid?.refreshDataSource();
                } catch (e) {
                    if (e.response && e.response.status === 400) {
                        console.error('Bad Request:', e.response.data);
                        this.errorToast({ text: e.response.data });
                    } else {
                        console.error(e);
                        this.errorToast({ text: 'Failed to create notification campaign. Please try again.' });
                    }
                }
            },

            async getSendToCount() {
                try {
                    const response = await API.get(`${MASS_PUSH_NOTIFICATION_ENDPOINT()}send-to-count/`, {
                        params: {
                            send_to: this.formatSendTo,
                        },
                    });
                    this.sendToCount = response.data.count;
                } catch (error) {
                    console.error(error);
                }
            },

            async getRules() {
                try {
                    const response = await API.get(`${MASS_PUSH_NOTIFICATION_ENDPOINT()}send-to-rules/`);
                    this.sendToRules = response.data.rules || '';

                    this.sendToRulesOptions = [
                        {
                            value: null,
                            text: 'Select Rule',
                        },
                        ...this.sendToRules.map((rule) => {
                            return {
                                value: rule[0],
                                text: rule[1],
                            };
                        }),
                    ];
                } catch (error) {
                    console.error(error);
                }
            },

            addRule() {
                this.rulesArray.push([null, null]);
            },
            removeRule(index) {
                if (this.rulesArray[index][0] == 7) {
                    this.selectedGuests = [];
                }
                this.rulesArray.splice(index, 1);
            },
            updateSelectedRule(index) {
                this.rulesArray[index][1] = null;
                if (this.rulesArray[index][0] == 7) {
                    this.selectedGuests = [];
                }
            },
            formatDate() {
                const date = new Date();
                const formattedDate = format(date, this.userUnicodeDateFormat);
                return `${formattedDate}`;
            },
            updateSegmentSelected(val) {
                this.segmentSelected = val;
            },
            updateModalSegmentSelected(val) {
                this.modalSegmentSelected = val;
            },
        },

        watch: {
            rulesArray() {
                this.getSendToCount();
            },
            selectedGuests() {
                this.getSendToCount();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .notification-ui {
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 5px;
        padding: 1rem;
        margin-top: 1.5rem;
        margin-bottom: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    .notification-ui img {
        width: 50px;
        height: 50px;
        margin: 0.5rem;
        margin-right: 1rem;
    }

    .notification-content h3 {
        margin: 0;
        font-size: 1.25rem;
    }

    .notification-content {
        display: flex;
        width: 100%;
        flex-direction: column;
    }

    .notification-content p {
        margin: 0.5rem 0;
    }

    .notification-content small {
        display: block;
        color: #6c757d;
    }

    .notification-header {
        display: flex;
        justify-content: space-between;
    }

    .notification-expand-button {
        display: flex;
        flex-direction: row-reverse;
    }

    .title-header {
        margin-top: 0.5rem;
    }

    .message-container {
        background-color: #f9f9f9;
        padding: 15px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        margin-top: 10px;
    }

    .device-preview {
        user-select: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: 1px solid #ced4da;
        padding: 5px;
        padding-top: 0px;
        border-radius: 5px;
        background-color: #e3e3e3;
        aspect-ratio: 735/938;
        height: fit-content;
        max-height: 940px;
        width: 100%;
    }

    .estimated-reach-div {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin: 10px 10px 0px;
    }

    .estimated-reach-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50%;
        min-width: fit-content;
        max-width: 375px;
        flex-direction: row;
        background-color: red;
        border-radius: 5px;
    }

    .estimated-reach-text {
        color: white;
        font-size: 1.25rem;
        margin: 8px;
        padding: 0px;
    }
</style>
